<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>表示評価：{{ evaluationLabel }}</div>
    <div>時間帯：{{ hourFrom }}時台 ～ {{ hourTo }}時台</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    evaluation: {
      type: String,
      default: '',
    },
    hourFrom: {
      type: Number,
      default: 0,
    },
    hourTo: {
      type: Number,
      default: 23,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    evaluationLabel() {
      return this.$store.state.labels.evaluationsPos[this.evaluation]
    },
  },
}
</script>
